import { render, staticRenderFns } from "./SettingsCharts.vue?vue&type=template&id=c04f8b9e&"
import script from "./SettingsCharts.vue?vue&type=script&lang=ts&"
export * from "./SettingsCharts.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsCharts.vue?vue&type=style&index=0&id=c04f8b9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports